import {NativeModules} from "react-native";

const _getAbConfig = async () => {
  try {
    if (window?.localStorage) {
      return await JSON.parse(window.localStorage.getItem('brc_ab'));
    }else {
      return null;
    }
  } catch (e) {
    console.log('ab Errored out', e);
    return null;
  }
};


const _getPokusConfig = async () => {
  try {
    if (window?.localStorage) {
      return await JSON.parse(window.localStorage.getItem('brc_pokus'));
    }else {
      return null;
    }
  } catch (e) {
    console.log('pokus Errored out', e);
    return null;
  }
};

NativeModules.AbConfigModule = {
  getAbConfig: _getAbConfig,
  getPokusConfig: _getPokusConfig
};
